export const hasDuplicateInputs = (inputs) => {
    const inputKeys = new Set(inputs.map((input) => input.toKeyString()));
    return inputs.length !== inputKeys.size;
};
export const hasIntersectingInputs = (a, b) => {
    const inputsA = new Set(a.map((input) => input.toKeyString()));
    return b.some((input) => inputsA.has(input.toKeyString()));
};

//# sourceMappingURL=common.js.map
